<cipo-paged-data-list
    class="compact-paginator full-height"
    fxLayout="column"
    fxLayoutAlign="space-between"
    [options]="tableOptions"
    [tableData]="tableData()"
    [tableColumns]="tableColumns"
    (rowClicked)="openPdfMarkup($event)"
    data-testid="pdf-markup-tab" />
